import { TPlanCode } from '@/contexts/billingContext/domain/types';

export const getIsAdditionalPlanCode = (planCode?: TPlanCode | null): boolean => !!planCode?.startsWith('tms.add_on.');
